const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const GET_WESTWORLD_SUCCESS = 'GET_WESTWORLD_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const REQ_DATA= {
  "flowType":"FWA_UPGRADE",
  "intent": "EUP_5G",
  "processStep": "Initiate",
  "processAction": "UpgradeNow",
}
const START_LOADING='START_LOADING';
const STOP_LOADING= 'STOP_LOADING';

// ADD DEVICE API
const INITIATE_ADD_DEVICE_API = 'INITIATE_ADD_DEVICE_API';
const ADD_DEVICE_SUCCESS = 'ADD_DEVICE_SUCCESS';
const ADD_DEVICE_ERROR = 'ADD_DEVICE_ERROR';

export {
  GET_DATA_FROM_API,
  GET_WESTWORLD_SUCCESS,
  ERR_OCCURED,
  REQ_DATA,
  INITIATE_ADD_DEVICE_API,
  ADD_DEVICE_ERROR,
  ADD_DEVICE_SUCCESS,
  START_LOADING,
  STOP_LOADING,
};